import React from 'react';
import FoodsNewsData from './../FoodsNewsData/FoodsNewsData';

const FoodsNews = () => {
    console.log(FoodsNewsData);
    return (
        <div>
            <section className='food-news'>
                <div className='container'>
                    <div className='row'>
                        <div className='title'>
                            <h3>Why you choose us</h3>
                            <p>Barton waited twenty always repair in within we do. An delighted offending
                                <br />
                                curiosity my is dashwoods at. Boy prosperous increasing surrounded.
                            </p>
                        </div>
                    </div>
                    <div className='row'>
                    {
                        FoodsNewsData.map(data => {
                            const {images, title, favIcon, description } = data

                            return(
                                <div className='col-lg-4'>
                                <img src={images} alt="img"  class="img-fluid" />
                                <div className='others'>
                                    <div className='icon'>
                                       <img src={favIcon} alt=""  />
                                    </div>
                                    <div className='content'>
                                        <h6>{title}</h6>
                                        <p>{description}</p>
                                        <span>See more  </span> <i className='fa fa-arrow-right'></i>
                                    </div>
                                </div>
                            </div>
                            )
                        })
                    }
                     
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FoodsNews;